import { Component, Listen, Prop, State, h } from '@stencil/core';
import { ConversationalSearchMessagesInitialQuestion } from '../../predefined/initial-question/initial-question';
import { getTermsAndConditionsSessionStorageValue } from '../../../conversational-search-logic/storage-manager/storage-manager-helpers';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

@Component({
  tag: 'uiaas-search-widget-conversational-search-messages-initial-mediator',
  shadow: false,
})
export class ConversationalSearchMessagesInitialMediator {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly searchQuery: string;
  @Prop() readonly acceptanceCallback: () => void;

  @State() isTermsAccepted = false;
  @State() isNewConversation = false;

  private conversationStartQuery: string;

  @Listen('conversational-search:user-start-of-conversation', {
    target: 'window',
  })
  userQuestionStatetHandler() {
      this.isTermsAccepted = true;
      this.acceptanceCallback();
      this.conversationStartQuery = this.searchQuery;
  }

  @Listen('conversational-search:user-new-conversation', {
    target: 'window',
  })
  userNewConversationHandler() {
      this.isNewConversation = true;
  }

  private newConversationTemplate = () => (
    <uiaas-conversational-search-message-new-conversation
      labelProvider={(e, f) => this.labelProvider(e, f)}
      query={this.searchQuery}
    />
  );

  connectedCallback() {
      if (getTermsAndConditionsSessionStorageValue()) {
        this.isNewConversation = true;
      }
  }

  componentWillLoad() {
      if (getTermsAndConditionsSessionStorageValue()) {
        this.conversationStartQuery = this.searchQuery;
      }
  }

  render() {
      if ((!getTermsAndConditionsSessionStorageValue() || this.isTermsAccepted) && !this.isNewConversation)
        return (
          <section>
            <uiaas-search-conversational-search-messages-wrapper isQuestionVariant={true} labelProvider={(e, f) => this.labelProvider(e, f)}>
              <ConversationalSearchMessagesInitialQuestion query={this.conversationStartQuery ?? this.searchQuery} />
            </uiaas-search-conversational-search-messages-wrapper>
            <uiaas-search-conversational-search-messages-wrapper labelProvider={(e, f) => this.labelProvider(e, f)}>
              <uiaas-search-conversational-search-message-terms-and-conditions labelProvider={(e, f) => this.labelProvider(e, f)} query={this.searchQuery}/>
            </uiaas-search-conversational-search-messages-wrapper>
            {this.isTermsAccepted ? (
              <uiaas-search-conversational-search-messages-wrapper isQuestionVariant={true} labelProvider={(e, f) => this.labelProvider(e, f)}>
                <span>{this.labelProvider('conversational.search.chat.terms.and.conditions.message.acceptance', 'I Accept Terms and Conditions')}</span>
              </uiaas-search-conversational-search-messages-wrapper>
            ) : (
              ''
            )}
          </section>
        );

      if (this.isNewConversation) return this.newConversationTemplate();
  }
}
